
<div :class="['card-profile-sales-graph', { full: page }]">
  <card-profile-sales-graph-header
    :auction-only="card.auctionOnly"
    :is-public="isPublic"
    :card-id="cardId"
    :card="card"
  />

  <div class="container">
    <div>
      <sales-stats :timeline-data="timelineData" :page="page" />
    </div>

    <graph
      :label="card.label"
      :labels="labels"
      :datasets="datasets"
      :zoom.sync="localZoom"
      :scale.sync="localScale"
      :is-public="isPublic"
      @saleClicked="handleSaleClicked"
    />
  </div>
</div>
